<template>
  <div class="z-[3] relative bg-white min-h-screen bg-white text-black text-base font-normal leading-relaxed tracking-tight">
    <main class="pt-20">
      <div class="mx-auto max-w-6xl px-8 py-16 md:px-28 md:py-24">
        <h1 class="text-5xl font-medium md:text-6xl lg:text-7xl mb-8">{{ t('pages.terms.hero.title') }}</h1>
        <div class="text-lg mb-8">
          <p>{{ t('pages.terms.hero.effective', { date: t('pages.terms.hero.effectiveDate') }) }}</p>
          <p>{{ t('pages.terms.hero.updated', { date: t('pages.terms.hero.updatedDate') }) }}</p>
        </div>

        <div class="prose prose-lg max-w-none">
          <section v-for="section in sections" :key="section.id" class="mb-12">
            <component
              :is="section.level === 'h2' ? 'h2' : 'h3'"
              class="font-medium mb-4"
              :class="section.level === 'h2' ? 'text-3xl' : 'text-2xl'"
            >
              {{ section.title }}
            </component>
            <p v-for="paragraph in section.paragraphs" :key="paragraph" class="mb-4">
              {{ paragraph }}
            </p>
            <ul v-if="section.list?.length" class="list-disc pl-6 mb-8">
              <li v-for="item in section.list" :key="item">{{ item }}</li>
          </ul>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '#imports'
import { useSeo } from '~/composables/useSeo'

definePageMeta({
  layout: 'default'
})

const { t, tm } = useI18n()

useSeo({
  title: t('pages.terms.meta.title'),
  description: t('pages.terms.meta.description'),
  keywords: 'ommi.shop terms of service, terms and conditions, seller agreement, marketplace terms',
  type: 'website'
})

type TermsSection = {
  id: string
  level: 'h2' | 'h3'
  title: string
  paragraphs: string[]
  list?: string[]
}

const sections = computed(() => (tm('pages.terms.sections') as TermsSection[]) ?? [])
</script>

<style scoped lang="postcss">
.prose {
  @apply text-black;
}

.prose h2 {
  @apply text-3xl font-medium mb-4;
}

.prose h3 {
  @apply text-2xl font-medium mb-4;
}

.prose p {
  @apply mb-4;
}

.prose ul {
  @apply mb-8;
}

.prose li {
  @apply mb-2;
}
</style> 